<template>
  <div>
    <!--v-show="show"-->
    <div align="right">
      <el-form :inline="true" class="style1">
        <el-form-item>
          <el-button class="el-icon-circle-plus-outline" type="text" @click="dialogVisible = true">
            {{$t("general.add")}}
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table :data="tableData" highlight-current-row border style="width: 100%; margin-top: 0px" :empty-text="$t('general.empty_data')">

      <el-table-column :label="$t('general.date')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.date }}</span>
        </template>
      </el-table-column>

      <el-table-column　:label="$t('companyInfo.name')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.comName }}</span>
        </template>
      </el-table-column>

      <el-table-column　:label="$t('empList.name')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.empName }}</span>
        </template>
      </el-table-column>

      <el-table-column　label="給付金の種類" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.type }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('general.operation')" align="center" width="360">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">
            {{$t("general.edit")}}
          </el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)">
            {{$t("general.delete")}}
          </el-button>
          <el-button size="mini" type="success" icon="el-icon-view" @click="printPDF(scope.$index, scope.row)">
            {{$t("general.print")}}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pages">
      <el-pagination background :disabled="disablePage" :current-page.sync="currentPage" small layout="prev, pager, next" :page-size="pageSize" :total="total" @current-change="handleCurrentChange">
      </el-pagination>
    </div>

    <!-- adding new -->
    <el-dialog :title="$t('general.add')" :append-to-body="true" :visible.sync="dialogVisible" width="60%" :before-close="handleClose">
      <el-form :model="inputForm" :rules="rules" ref="inputForm" label-width="9rem" class="demo-inputForm" size="medium" :label-position="labelPosition" style="width: 90%; margin-left: 5%; margin-right: 5%;">
        <el-input type="hidden" v-model="inputForm.id" />

        <el-row :gutter=50>
          <el-col :md=12>
            <el-form-item :label="$t('general.date')+':'" prop="date">
              <el-date-picker v-model="inputForm.date" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 100%;" :placeholder="$t('general.please_select')">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :md=12>
            <el-form-item :label="$t('companyInfo.name')+':'" prop="company_id">
              <el-select v-model="inputForm.company_id" clearable size="mini" :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')" style="width: 100%;">
                <el-option v-for="item in companyInfo" :key="item.id" :label="item.name1" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter=50>
          <el-col :md=12>
            <el-form-item label="死亡年月日">
              <el-date-picker v-model="inputForm.expiredDate" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 100%;" :placeholder="$t('general.please_select')">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :md=12>
            <el-form-item label="給付金の種類:">
              <el-select v-model="inputForm.type" :placeholder="$t('general.select')" clearable size="mini" style="width: 100%">
                <el-option v-for="item in types" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter=50>
          <el-col :md=12>
            <el-form-item label="支給番号:" prop="paymentNo">
              <el-input v-model="inputForm.paymentNo" size=mini prefix-icon="el-icon-edit" placeholder="12-123456-1"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md=12>
            <el-form-item label="死亡した者との関係:">
              <el-input v-model="inputForm.relationship" size=mini prefix-icon="el-icon-edit"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-form-item label="死亡した者:">
            <el-row :gutter=20 class="borderBox">
              <el-col :md=12>
                <el-form-item :label="$t('general.employee_id') + ':'" prop="empIdDeath" label-width="6rem">
                  <el-select v-model="inputForm.empIdDeath" clearable size="mini" :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')" style="width: 100%;">
                    <el-option v-for="item in empList" :key="item.id" :label="item.employee_id" :value="item.employee_id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md=12>
                <el-form-item :label="$t('empList.name') + ':'" prop="empIdDeath" label-width="4rem">
                  <el-select v-model="inputForm.empIdDeath" clearable size="mini" :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')" style="width: 100%;">
                    <el-option v-for="item in empList" :key="item.id" :label="item.name" :value="item.employee_id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form-item>
        </el-row>

        <el-row>
          <el-form-item label="請 求 者:">
            <el-row :gutter=20 class="borderBox">
              <el-col :md=12>
                <el-form-item :label="$t('general.employee_id') + ':'" prop="empIdRequester" label-width="6rem">
                  <el-select v-model="inputForm.empIdRequester" clearable size="mini" :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')" style="width: 100%;">
                    <el-option v-for="item in empList" :key="item.id" :label="item.employee_id" :value="item.employee_id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md=12>
                <el-form-item :label="$t('empList.name') + ':'" prop="empIdRequester" label-width="4rem">
                  <el-select v-model="inputForm.empIdRequester" clearable size="mini" :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')" style="width: 100%;">
                    <el-option v-for="item in empList" :key="item.id" :label="item.name" :value="item.employee_id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form-item>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="add('inputForm')" type="primary" size="medium">
          {{$t("general.confirm")}}
        </el-button>
        <el-button style="width:120px" @click="cancel()" size="medium">
          {{$t("general.cancel")}}
        </el-button>
      </span>
    </el-dialog>

    <!-- edit -->
    <el-dialog :title="$t('general.edit')" :append-to-body="true" :visible.sync="dialogEdit" width="60%" :before-close="handleClose">
      <el-form :model="inputForm" :rules="rules" ref="inputForm" label-width="9rem" class="demo-inputForm" size="medium" :label-position="labelPosition" style="width: 90%; margin-left: 5%; margin-right: 5%;">
        <el-input type="hidden" v-model="inputForm.id" />

        <el-row :gutter=50>
          <el-col :md=12>
            <el-form-item :label="$t('general.date')+':'" prop="date">
              <el-date-picker v-model="inputForm.date" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 100%;" :placeholder="$t('general.please_select')">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :md=12>
            <el-form-item :label="$t('companyInfo.name')+':'" prop="company_id">
              <el-select v-model="inputForm.company_id" size="mini" :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')" style="width: 100%;">
                <el-option v-for="item in companyInfo" :key="item.id" :label="item.name1" :value="item.id" disabled>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter=50>
          <el-col :md=12>
            <el-form-item label="死亡年月日">
              <el-date-picker v-model="inputForm.expiredDate" size="mini" value-format="yyyy-MM-dd" type="date" style="width: 100%;" :placeholder="$t('general.please_select')">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :md=12>
            <el-form-item label="給付金の種類:">
              <el-select v-model="inputForm.type" :placeholder="$t('general.select')" clearable size="mini" style="width: 100%">
                <el-option v-for="item in types" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter=50>
          <el-col :md=12>
            <el-form-item label="支給番号:" prop="paymentNo">
              <el-input v-model="inputForm.paymentNo" size=mini prefix-icon="el-icon-edit" placeholder="12-123456-1"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md=12>
            <el-form-item label="死亡した者との関係:">
              <el-input v-model="inputForm.relationship" size=mini prefix-icon="el-icon-edit"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-form-item label="死亡した者:">
            <el-row :gutter=20 class="borderBox">
              <el-col :md=12>
                <el-form-item :label="$t('general.employee_id') + ':'" prop="empIdDeath" label-width="6rem">
                  <el-select v-model="inputForm.empIdDeath" clearable size="mini" :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')" style="width: 100%;">
                    <el-option v-for="item in empList" :key="item.id" :label="item.employee_id" :value="item.employee_id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md=12>
                <el-form-item :label="$t('empList.name') + ':'" prop="empIdDeath" label-width="4rem">
                  <el-select v-model="inputForm.empIdDeath" clearable size="mini" :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')" style="width: 100%;">
                    <el-option v-for="item in empList" :key="item.id" :label="item.name" :value="item.employee_id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form-item>
        </el-row>

        <el-row>
          <el-form-item label="請 求 者:">
            <el-row :gutter=20 class="borderBox">
              <el-col :md=12>
                <el-form-item :label="$t('general.employee_id') + ':'" prop="empIdRequester" label-width="6rem">
                  <el-select v-model="inputForm.empIdRequester" clearable size="mini" :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')" style="width: 100%;">
                    <el-option v-for="item in empList" :key="item.id" :label="item.employee_id" :value="item.employee_id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md=12>
                <el-form-item :label="$t('empList.name') + ':'" prop="empIdRequester" label-width="4rem">
                  <el-select v-model="inputForm.empIdRequester" clearable size="mini" :empty-text="$t('general.empty_data')" :placeholder="$t('general.please_select')" style="width: 100%;">
                    <el-option v-for="item in empList" :key="item.id" :label="item.name" :value="item.employee_id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form-item>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="edit('inputForm')" type="primary" size="medium">
          {{$t("general.confirm")}}
        </el-button>
        <el-button style="width:120px" @click="cancel()" size="medium">
          {{$t("general.cancel")}}
        </el-button>
      </span>
    </el-dialog>
    <div style="text-align: left; margin-top: 50vh; margin-left: 2%; margin-right: 2%; font-size: smaller; width: fit-content; ">
      <el-row>
        <el-card style="background-color: #51d1ff1c;">
          注意
          <ul>
            <li>
              この請求書は支給を受けることができる者が死亡した日の翌日から起算して6 か月以内に、原則として死亡した受給資格者等の死亡の当時の住所又は居所を管轄
              する公共職業安定所又は地方運輸局の長（ただし、教育訓練給付金、教育訓練支援給付金、高年齢雇用継続基本給付金、高年齢再就職
              給付金、育児休業給付金、介護休業給付金は公共職業安定所の長に限る。）に提出すること。
            </li>
          </ul>
        </el-card>
      </el-row>
    </div>

  </div>
</template>
<script>
export default {

  data() {

    return {
      pageSize: 6,
      currentPage: 1,
      total: 0,
      disablePage: false,

      labelPosition: "left",

      dialogVisible: false,
      dialogEdit: false,

      tableData: [],
      companyInfo: [],
      empList: [],

      inputForm: {
        id: "",
        company_id: "",
        date: "",
        type: "",
        empIdDeath: "",
        expiredDate: "",
        paymentNo: "",
        empIdRequester: "",
        relationship: ""
      },

      rules: {
        date: [{
          required: true,
          message: this.$t("general.please_select"),
          trigger: "blur",
        },],
        company_id: [{
          required: true,
          message: this.$t("general.please_select"),
          trigger: "blur",
        },],
        empIdDeath: [{
          required: true,
          message: this.$t("general.please_select"),
          trigger: "blur",
        },],
        empIdRequester: [{
          required: true,
          message: this.$t("general.please_select"),
          trigger: "blur",
        },],
        paymentNo: [{
          pattern: /[0-9]{2}\-[0-9]{6}\-[0-9]{1}/,
          message: "12-123456-1の形で入力してください。",
          trigger: "blur"
        }]
      },

      types: [{
        value: "育児休業給付",
        label: "育児休業給付",
      }, {
        value: "高年齢雇用継続給付",
        label: "高年齢雇用継続給付",
      }, {
        value: "介護休業給付",
        label: "介護休業給付",
      },],
    };
  },
  methods: {
    preview(row) {
      //   var uid = window.localStorage.getItem('LoginUserId');
      window.open(
        "/pdf/未支給失業等給付請求書-" + row.empName + row.date + ".pdf"
      );
    },

    printPDF(index, row) {
      let postData = this.qs.stringify({
        id: row.id
      });
      this.axios({
        method: "post",
        url: "/empInsRemoveBenefitPDF",
        data: postData
      })
        .then((response) => {
          if (response.data.status = "success") {
            this.$message({
              type: "success",
              message: this.$t("general.print_completed")
            });
            setTimeout(() => {
              this.preview(row);
            }, 300);
          } else {
            this.$message({
              type: "warning",
              message: this.$t("general.print_failed")
            });
          }
        })
        .catch(error => {
          this.$message({
            type: "warning",
            message: this.$t("general.print_failed")
          });
        });
    },


    add(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let postData = this.qs.stringify({
            company_id: this.inputForm.company_id,
            date: this.inputForm.date,
            type: this.inputForm.type,
            empIdDeath: this.inputForm.empIdDeath,
            expiredDate: this.inputForm.expiredDate,
            paymentNo: this.inputForm.paymentNo,
            empIdRequester: this.inputForm.empIdRequester,
            relationship: this.inputForm.relationship

          });
          this.axios({
            method: "post",
            url: "/insertEmpInsRemoveBenefit",
            data: postData
          })
            .then(response => {
              this.$message({
                type: "success",
                message: this.$t("general.add_completed")
              });
              this.currentPage = 1;
              this.getPages();
              this.dialogVisible = false;
              this.emptyForm();
            })
            .catch(error => {
              this.$message({
                type: "warning",
                message: this.$t("general.add_failed")
              });
              console.log(error);
            });
        } else {
          this.$message({
            type: "error",
            message: this.$t("general.valid_failed")
          });
          return false;
        }
      });
    },

    handleEdit(index, row) {
      this.dialogEdit = true;
      this.inputForm = Object.assign({}, row);
    },

    edit(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let postData = this.qs.stringify({
            id: this.inputForm.id,
            date: this.inputForm.date,
            type: this.inputForm.type,
            empIdDeath: this.inputForm.empIdDeath,
            expiredDate: this.inputForm.expiredDate,
            paymentNo: this.inputForm.paymentNo,
            empIdRequester: this.inputForm.empIdRequester,
            relationship: this.inputForm.relationship
          });
          this.axios({
            method: "post",
            url: "/updateEmpInsRemoveBenefit",
            data: postData
          })
            .then(response => {
              this.handleCurrentChange();
              this.dialogEdit = false;
              this.emptyForm();
              this.$message({
                type: "success",
                message: this.$t("general.edit_completed")
              });
              // console.log(response);
            })
            .catch(error => {
              this.$message({
                type: "warning",
                message: this.$t("general.edit_failed")
              });
              console.log(error);
            });
        } else {
          console.log("error submit!!");
          this.$message({
            type: "error",
            message: this.$t("general.valid_failed")
          });
          return false;
        }
      });
    },

    handleDelete(index, row) {
      this.$confirm(this.$t("general.sure_delete"), this.$t("general.hint"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: "OK",
        cancelButtonText: this.$t("general.cancel"),
        type: "warning"
      })
        .then(() => {
          let postData = this.qs.stringify({
            id: row.id
          });
          this.axios({
            method: "post",
            url: "/deleteEmpInsRemoveBenefit",
            data: postData
          })
            .then(response => {
              this.getPages();
              this.$message({
                type: "success",
                message: this.$t("general.delete_completed")
              });
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("general.canceled")
          });
        });
    },

    jump(path) {
      this.$router.push(path);
    },

    cancel() {
      this.dialogVisible = false;
      this.dialogEdit = false;
      this.emptyForm();
    },

    emptyForm() {
      this.inputForm = {
        id: "",
        company_id: "",
        date: "",
        type: "",
        empIdDeath: "",
        expiredDate: "",
        paymentNo: "",
        empIdRequester: "",
        relationship: ""
      }
      this.$refs['inputForm'].resetFields();
    },

    handleClose(done) {
      this.$confirm(this.$t("general.close_comfirm"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: this.$t("general.confirm"),
        cancelButtonText: this.$t("general.cancel"),
        type: "warning"
      })
        .then(_ => {
          done();
          this.emptyForm();
        })
        .catch(_ => { });
    },

    handleCurrentChange() {
      let postData = this.qs.stringify({
        page: this.currentPage
      });
      this.axios({
        method: "post",
        url: "/pageEmpInsRemoveBenefit",
        data: postData
      })
        .then(response => {
          this.tableData = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    getPages() {
      this.axios
        .post("/pageEmpInsRemoveBenefit")
        .then(response => {
          this.show = true
          this.tableData = response.data;
        })
        .catch(error => {
          this.show = false;
          this.$message({
            type: 'error',
            message: '開発中です。'
          });
          console.log(error);
        });
      this.axios
        .post("/rowsEmpInsRemoveBenefit")
        .then(response => {
          this.total = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
  },

  created() {
    this.getPages();
    //get Company List
    this.axios
      .post("/ListComInfo")
      .then((response) => {
        this.companyInfo = response.data;
      })
      .catch((error) => {
        console.log(error);
      });

    //get Employee Name
    this.axios
      .post("/ListEmpListForInsNameChange")
      .then(response => {
        this.empList = response.data;
      })
      .catch(error => {
        console.log(error);
      });
  }
};
</script>

<style scoped>
.style1 {
  margin-right: 100px;
  padding: 0px;
  text-align: right;
}

.pages {
  margin: 0px;
  padding: 0px;
  text-align: right;
}

.borderBox {
  background-color: #eff0f0a6;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  /* border: rgb(204, 204, 204) 1px solid; */
  padding: 2%;
}
</style>


// WEBPACK FOOTER //
// src/components/EmpIns/EmpInsRemoveBenefit.vue